<template>
  <div :data-test="`tc-worker-type-${index}`">
    <WdsLabel
      :primary="variant === 'primary'"
      :warning="variant === 'warning'"
      :subtle="variant === 'subtle'"
      xs
    >
      {{ label }}
    </WdsLabel>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { TrustedContactManagedStatus } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const TrustedContactWorkerTypeColumn = graphql(`
  fragment TrustedContactWorkerTypeColumn on TrustedContact {
    id
    managedStatus
  }
`)

const props = defineProps<{
  row: FragmentType<typeof TrustedContactWorkerTypeColumn>
  index: number
}>()

const column = computed(() => useFragment(TrustedContactWorkerTypeColumn, props.row))

const display = computed<{ label: string; variant: 'primary' | 'subtle' | 'warning' }>(() => {
  switch (column.value.managedStatus) {
    case TrustedContactManagedStatus.StaffingAgency:
      return { label: $t('Managed'), variant: 'primary' }
    case TrustedContactManagedStatus.Unmanaged:
      return { label: $t('Unmanaged'), variant: 'warning' }
    default:
      return { label: $t('Worker account'), variant: 'subtle' }
  }
})

const label = computed(() => display.value.label)
const variant = computed(() => display.value.variant)
</script>
